import api from './api';

export const notificationService = {
  // Get all notifications for the current user
  getNotifications: async ({ page = 1, limit = 20, tenantId } = {}) => {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });

    if (tenantId) {
      params.append('tenantId', tenantId);
    }

    return await api.get(`/notifications?${params.toString()}`);
  },

  // Get notification by ID
  getNotificationById: async (id) => {
    return await api.get(`/notifications/${id}`);
  },

  // Get unread count
  getUnreadCount: async (tenantId) => {
    const query = tenantId ? `?tenantId=${tenantId}` : '';
    return await api.get(`/notifications/unread/count${query}`);
  },

  // Mark notification as read
  markAsRead: async (id) => {
    return await api.patch(`/notifications/${id}/read`);
  },

  // Mark all notifications as read
  markAllAsRead: async () => {
    return await api.patch('/notifications/read-all');
  },

  // Delete notification
  deleteNotification: async (id) => {
    return await api.delete(`/notifications/${id}`);
  },

  // Delete all notifications
  deleteAllNotifications: async () => {
    return await api.delete('/notifications');
  },
};

export default notificationService;


